export default {"src":"/_next/static/media/nav-logo.06ce4405.svg","height":56,"width":220,"blurWidth":0,"blurHeight":0};